<template>
  <div class="login-wrapper">
    <a class="logo logo_type_c" v-if="isBrosaib"></a>
    <h3 style="text-align: center;">사입 삼촌 페이지</h3>
    <form class="login">
      <a-input
        v-model="auth.identity"
        placeholder="아이디"
        autocomplete="username"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <a-input
        type="password"
        v-model="auth.password"
        placeholder="비밀번호"
        autocomplete="password"
        class="ipt_type_1 password"
        :disabled="isLoading"
      />

      <div class="btn_wrapper">
        <a
          class="btn_type_1 btn_effect ef_type_2"
          v-on:click="submit"
          :disabled="isLoading"
        >{{ !isLoading ? '로그인' : '로그인 중...' }}</a>

        <div class="login_btn_wrapper">
          <router-link to="/uncle/find" class="a_type_1 text-center">비밀번호 찾기</router-link>&nbsp;
          <router-link to="/" class="a_type_1 text-center">사용자</router-link>&nbsp;
          <router-link to="/admin" class="a_type_1 text-center">관리자</router-link>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "UncleAuthSignin",
  data() {
    return {
      isLoading: false /* 로딩 상태 */,
      auth: {
        identity: "" /* 아이디 */,
        password: "" /* 비밀번호 */
      }
    };
  },
  methods: {
    ...mapActions(["uncleSignin"]),
    submit() {
      this.isLoading = true;
      this.uncleSignin(this.auth).then(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>